import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonContent,
  IonHeader,
  IonList,
  IonLoading,
  IonModal,
  IonSearchbar,
  IonTitle,
  IonToast,
  IonToolbar,
  useIonAlert,
  useIonRouter,
} from "@ionic/react";
import React, { useContext, useState, useRef } from "react";
import { findRequisitions } from "../api/Requisitions";
import { decodeParam, encodeParam } from "../util/ApiHelper";
import { TranslationsContext, TranslationMessagesContext } from "../util/Translations";
import CardExpandableHeader from "../components/CardExpandableHeader";
import BarcodeScannerButton from "./BarcodeScannerButton";
import { StoresProps } from "../models/stores/Stores";
import StoresPopover from "./StoresPopover";
import {
  CriteriaParameter,
  FilterParam,
  maxResults,
  useQueryExec,
} from "../hooks/useQueryExec";
import QueryFilter from "./QueryFilter";
import SearchFooter from "./SearchFooter";
import WorkOrderResults from "./WorkOrderResults";
import QueryResults from "./QueryResults";
import { useParams } from "react-router";

const StoresRequisition: React.FC<StoresProps> = (props) => {
  const { translations } = useContext(TranslationsContext);
  const { expanded, setExpanded, storesTab } = props;
  const popover = useRef<HTMLIonPopoverElement>(null);
  const router = useIonRouter();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [searchResults, setSearchResults] = useState<string[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [presentAlert] = useIonAlert();
  const [isOpen, setIsOpen] = useState(false);
  const [searchYn, setSearchYn] = useState(false);
  const [criteriaParams, setCriteriaParams] = useState<CriteriaParameter[]>();


  const confirmSearch = async (
    currentQuery: string,
    filterParams?: FilterParam[],
    parameters?: CriteriaParameter[]
  ) => {
    setQueryRows([]);
    setCriteriaParams(parameters);
    setQueryName(currentQuery);
    setSearchYn(true);
    handleOpen();
  };

  const {
    getQueryList,
    queryList,
    getFilterParams,
    filterParams,
    setParameter,
    queryRows,
    setQueryRows,
    executeSearch,
    getPriorityCodes,
    getStatusCodes,
    errorState,
    totalCount,
    queryCriteria,
    getQueryCriteria,
    getNoOfFieldsToDisplay,
    showLoading,
    setShowLoading,
    showToast,
    setShowToast,
    execFilter,
    filterRows,
    resultsFilter,
  } = useQueryExec("Requisition",
    "Requisition",
    "requisition",
    undefined,
    true);
  const handleExpand = (expanded: boolean) => {
    setExpanded(expanded);
  };
  const storesRoute = true;
  const querySection = "QW--Requisition";
  const [queryName, setQueryName] = useState("");
  const { translatedMessages } = useContext(TranslationMessagesContext);

  const handleRequisitionsSearch = (e: CustomEvent) => {
    let newVal = e.detail.value;
    setSearchValue(newVal);
    if (newVal.length >= 2) {
      findRequisitions(newVal).then((res) => {
        if (res.status === 200) {
          if (res.data.length > 0) {
            popover.current!.event = e;
            setPopoverOpen(true);
          } else if (popoverOpen) {
            setPopoverOpen(false);
          }
          setSearchResults(res.data);
        }
      });
    } else {
      if (popoverOpen) {
        setPopoverOpen(false);
      }
      if (searchResults.length > 0) {
        setSearchResults([]);
      }
    }
  };

  const onBarcodeScan = (text?: string) => {
    if (text) {
      router.push(
        `/Stores/Requisitions/${encodeParam(text)}/${storesTab}`
      );
    } else {
      presentAlert({
        message: "Requisition could not be found",
        buttons: ["OK"],
      });
    }
  };


  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  const ResultsModal = (
    <IonModal isOpen={isOpen} onIonModalWillDismiss={handleClose}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={handleClose}>
              {translations["lbl_btn_cancel"] || "Cancel"}
            </IonButton>
          </IonButtons>
          <IonTitle>{translations["lbl_reqs"] || "Requisition"}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <QueryFilter
          setShowLoading={setShowLoading}
          getQueryList={getQueryList}
          queryList={queryList}
          querySection={querySection}
          getFilterParams={getFilterParams}
          filterParams={filterParams}
          setParameter={setParameter}
          queryCriteria={queryCriteria}
          getQueryCriteria={getQueryCriteria}
          searchCallback={confirmSearch}
        />
        <QueryResults
          searchYn={searchYn}
          setSearchYn={setSearchYn}
          queryName={queryName}
          queryParams={filterParams}
          criteria={criteriaParams}
          queryRows={queryRows}
          filterParams={filterParams}
          setParameter={setParameter}
          executeSearch={executeSearch}
          getNoOfFieldsToDisplay={getNoOfFieldsToDisplay}
          errorState={errorState}
          totalCount={totalCount}
          showLoading={showLoading}
          setShowLoading={setShowLoading}
          cardClick={handleClose}
          cardLink={`/Stores/Requisitions/replaceWithValue/${storesTab}`}
          filterRows={filterRows}
          filterMethod={execFilter}
          filterString={resultsFilter}
        />
      </IonContent>
      <SearchFooter totalRows={totalCount} filterRows={filterRows} />
    </IonModal>
  );

  return (
    <>
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        duration={5000}
      />

      {ResultsModal}

      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={
          translatedMessages["DisplayFirst"]?.MessageText.replace(
            "@1",
            maxResults
          )
            .replace("@2", translations["lbl_reqs"] || "Requisitions")
            .replace("@3", totalCount) ||
          `Displaying the first ${maxResults} requisitions of ${totalCount}.`
        }
        duration={2000}
        position="top"
      />
      <IonCard>
        <CardExpandableHeader
          expanded={expanded}
          onExpandClick={handleExpand}
          title={translations["lbl_reqs"] || "Requisitions"}
        />
        <IonCardContent hidden={!expanded} style={{ paddingTop: 0 }}>
          <IonList>
            {/**Regular search */}
            <IonSearchbar
              placeholder={
                translations["lbl_mob_enterrequisition"] ||
                "Enter Requisition Number"
              }
              showClearButton="focus"
              inputMode="text"
              type="text"
              id="req-searchbar"
              value={searchValue}
              onIonChange={handleRequisitionsSearch}
              debounce={500}
            ></IonSearchbar>
            {/**Run Query */}
            {/* <IonButton
              color="primary"
              expand="full"
              routerLink={`/Stores/Requisitions/${storesTab}`}
            >
              {translations["lbl_btn_mob_advancedsearch"] || "Advanced Search"}
            </IonButton> */}
            <IonButton
              color="primary"
              expand="full"
              onClick={() => handleOpen()}
            >
              {translations["lbl_btn_mob_advancedsearch"] || "Advanced Search"}
            </IonButton>
            {/**Barcode Scan */}
            <BarcodeScannerButton
              textButton
              onScan={onBarcodeScan}
              expand="block"
            />
          </IonList>
        </IonCardContent>
      </IonCard>
      <StoresPopover
        popover={popover}
        popoverOpen={popoverOpen}
        setPopoverOpen={setPopoverOpen}
        searchResults={searchResults}
        setSearchResults={setSearchResults}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        storesTab={storesTab}
      />
    </>
  );
};

export default StoresRequisition;
